var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1673 18.3334C27.6395 18.3334 28.0357 18.1734 28.3556 17.8534C28.6756 17.5334 28.8351 17.1378 28.834 16.6667C28.834 16.1945 28.674 15.7989 28.354 15.48C28.034 15.1612 27.6384 15.0012 27.1673 15C26.6951 15 26.2995 15.16 25.9806 15.48C25.6618 15.8 25.5018 16.1956 25.5007 16.6667C25.5007 17.1389 25.6607 17.535 25.9806 17.855C26.3007 18.175 26.6962 18.3345 27.1673 18.3334ZM13.834 15H22.1673V11.6667H13.834V15ZM8.00065 35C7.05621 31.8334 6.12565 28.6739 5.20898 25.5217C4.29232 22.3695 3.83398 19.14 3.83398 15.8334C3.83398 13.2778 4.72287 11.1112 6.50065 9.33337C8.27843 7.5556 10.4451 6.66671 13.0007 6.66671H21.334C22.1395 5.61115 23.119 4.79171 24.2723 4.20837C25.4256 3.62504 26.6684 3.33337 28.0007 3.33337C28.6951 3.33337 29.2857 3.57671 29.7723 4.06337C30.259 4.55004 30.5018 5.14004 30.5007 5.83337C30.5007 5.97226 30.4312 6.29171 30.2923 6.79171C30.1812 7.09726 30.0773 7.41004 29.9806 7.73004C29.884 8.05004 29.8073 8.37615 29.7506 8.70837L33.5423 12.5H37.1673V24.125L32.459 25.6667L29.6673 35H20.5007V31.6667H17.1673V35H8.00065Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.b9a79ab6.svg";
export { ForwardRef as ReactComponent };